import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SoccerProCanvas from './Canvas';
import mockData from '../../constants/soccerPro.mock.json';
import { updateOverlay } from '../../reducers/Builder/actions';

function SoccerProOverlay({ data, isBuilder, styles }) {
  const dispatch = useDispatch();
  const builder = useSelector(state => state.builder);
  const overlay = useSelector(state => state.overlay);
  const [selectedComponent, setSelectedComponent] = useState(null);

  // Use data from Redux state in builder mode, or props in overlay mode
  const builderData = isBuilder ? builder.data.data : data;

  // Use live data from overlay store if available, otherwise fallback to mock data (only in builder mode)
  const matchData = isBuilder ? mockData : overlay.matchData;
  
  // Use styles from Redux or props
  const customStyles = isBuilder ? builder.data.styles : styles;
  
  const canvasConfig = builderData?.canvas || {
    width: 1920,
    height: 1080,
    grid: true,
    zoom: 1,
    components: []
  };
  
  
  // Handle component selection
  const handleComponentSelect = (component) => {
    if (isBuilder) {
      setSelectedComponent(component);
    }
  };

  // Handle component updates
  const handleUpdateComponent = (componentId, updates) => {
    if (isBuilder) {
      const updatedComponents = canvasConfig.components.map(component =>
        component.id === componentId ? { ...component, ...updates } : component
      );
      
      dispatch(updateOverlay({
        data: {
          ...builderData,
          canvas: {
            ...canvasConfig,
            components: updatedComponents
          }
        }
      }));
    }
  };

  // Handle component deletion
  const handleDeleteComponent = (componentId) => {
    if (isBuilder) {
      const updatedComponents = canvasConfig.components.filter(
        component => component.id !== componentId
      );
      
      dispatch(updateOverlay({
        data: {
          ...builderData,
          canvas: {
            ...canvasConfig,
            components: updatedComponents
          }
        }
      }));
    }
  };

  // The WebSocket connection logic is now handled in the getOverlay action
  // This component simply uses the matchData from the Redux store

  return (
    <SoccerProCanvas
      matchData={matchData}
      canvasConfig={canvasConfig}
      onComponentSelect={handleComponentSelect}
      onUpdateComponent={handleUpdateComponent}
      onDeleteComponent={handleDeleteComponent}
      selectedComponent={selectedComponent}
      builderMode={isBuilder}
      theme={customStyles}
    />
  );
}

SoccerProOverlay.propTypes = {
  data: PropTypes.object,
  isBuilder: PropTypes.bool,
  styles: PropTypes.object,
};

SoccerProOverlay.defaultProps = {
  data: {},
  isBuilder: false,
  styles: {},
};

export default SoccerProOverlay;